module.exports = __webpack_public_path__ + "static/media/CompleteHouse.3b56824d.svg";